import { formatMoney } from '@betterment/core';
import { Box, Text } from '@betterment/samba-react';

import { TradeRowItem } from '../../../../types';

export const TradeRow: React.FC<{ item: TradeRowItem }> = ({ item }) => {
  const name = 'security' in item ? item.security.name : 'Cash';
  const symbol = 'security' in item ? item.security.symbol : undefined;
  const amount = formatMoney(item.amount);

  const shareInfo =
    item.shares && 'sharePrice' in item && item.sharePrice
      ? `${item.shares} shares @ ${formatMoney(item.sharePrice)}/share`
      : undefined;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Text variant="text100" color="text.weak">
          {name}
        </Text>
        {symbol && (
          <Text variant="text50" color="text.weak">
            {symbol}
          </Text>
        )}
      </Box>

      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text variant="text50" color="text.weak">
            Amount
          </Text>
          <Text variant="text50" color="text.weak">
            {amount}
          </Text>
        </Box>

        {shareInfo && (
          <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text variant="text50" color="text.weak">
              Shares
            </Text>
            <Text variant="text50" color="text.weak">
              {shareInfo}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};
